import { createLoaderImp } from '../../../components/ozmoit/common/loader-imp';
import { getRiskeEvaluationSessionDetails } from '../actions';

const {
  useLoaderData: useStudentRiskEvaluationSessionDetails,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({
  action: getRiskeEvaluationSessionDetails,
});

function StudentRiskEvaluationSessionDetailsLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export {
  StudentRiskEvaluationSessionDetailsLoader,
  useStudentRiskEvaluationSessionDetails,
};
